














import { Component, Vue } from "vue-property-decorator";
import { getBrowser } from '@/utils/browser';
import { Toast } from "vant";
const browser = getBrowser();

@Component({})
export default class AppDown extends Vue {
  androidUrl: string = '';
  iosUrl: string = '';
  isShowShade: boolean = false;

  mounted(){
    this.init();
  }

  init():void {
    (this as any).$apis.getDownUrl().then(res => {
      const { android_download_url, ios_download_url } = res;
      this.androidUrl = android_download_url;
      this.iosUrl = ios_download_url;
    })
  }

  handleDown() {
    if(browser.isWechat) {
      this.isShowShade = true;
      return false
    }
    if(browser.isAndroid){
      if(browser.isWechat){
        if(this.androidUrl.indexOf('.apk') > -1){
          this.isShowShade = true;
        } else {
          window.location.href = this.androidUrl;
        }
      }else {
        window.location.href = this.androidUrl;
      }
    } else if(browser.isIos){
      window.location.href = this.iosUrl;
    }
  }
}
